var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"basket-icon"},[_c('router-link',{staticClass:"h-icon",attrs:{"to":{name: 'cart'}}},[_c('cart-icon',{attrs:{"title":"Koszyk"}}),_vm._v(" "),_c('span',{staticClass:"badge"},[_vm._v(_vm._s(_vm.cartPositions))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cf2de88","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/redbay-b2b-layout/src/button/BasketIcon.vue
// module id = null
// module chunks = 